
		import async from 'preact-cli/async-component';

		function load(cb) {
			require.ensure([], function(require) {
				cb(require("!!../../../../../node_modules/preact-cli/node_modules/babel-loader/lib/index.js??ref--0!./index.js"));
			});
		}

		export default async(load);
	


//////////////////
// WEBPACK FOOTER
// ./checkout/components/async/codeintegration/index.js
// module id = null
// module chunks = 